
import {Options, Vue} from 'vue-class-component';
import {Button, Checkbox, TextButton, TextInput} from "@timenaut/timenaut-vue-common"
import axios, {AxiosError} from 'axios';
import ArrowRight from "@timenaut/timenaut-vue-common/lib/assets/icons/feather/arrow-right.svg"

@Options({
  components: {
    TextInput,
    Button,
    TextButton,
    Checkbox,
    ArrowRight,
  },
})
export default class extends Vue {
  email: string = "";

  pageHeader: string = "Recover your account";

  emailError: string = "";

  emailRegex = RegExp(/.*@.*\..*/);

  async recover() {
    this.emailError = "";

    if (!this.email.match(this.emailRegex)) {
      this.emailError = "Not a valid email";
      return;
    }

    axios.post(process.env.VUE_APP_API_URL + "/auth/recover", {
      email: this.email,
    })
        .then(() => {
          this.pageHeader = `Instructions for recovery have been sent to ${this.email}`;
        })
        .catch(() => {
          this.emailError = "Unexpected error occurred"
        })
  }
}
